<template>
  <div v-if="seller.id" class="step-container">
    <div class="custom-steps">
      <ul class="step-indicator">
        <li v-for="(step, index) in steps" :class="{ 'current-step': currentstep === index + 1 }">
          <span class="step-number">{{ index + 1 }}</span>
          <button class="steps-btn" :title="$t('wizard.step.company_data')">{{ step.title }}</button>
        </li>
      </ul>
    </div>
    <div class="steps-main">
      <div class="steps-content" v-if="currentstep == 1">
        <p>{{ $t('wizard.step.info') }}</p>
        <form>
          <div class="ls-box ls-box-gray ls-md-space">
            <fieldset class="row">
              <!-- Empresa -->
              <div class="input-block" :class="{'ls-error': errors.has($t('sellers.trade_name')) }">
                <label for="trade-name" class="col-sm-3 control-label ls-label-text">{{ $t('wizard.step.company_name') }}</label>
                <div class="col-sm-12 col-lg-6">
                  <div class="ls-prefix-group">
                    <span class="ls-label-text-prefix"><i class="fa fa-building" aria-hidden="true"></i></span>
                    <input
                      type="text"
                      class="form-control"
                      v-validate="'required'"
                      v-model="seller.trade_name"
                      :placeholder="$t('wizard.step.ph_pegasus_ag')"
                      :name="$t('sellers.trade_name')" />
                  </div>
                  <small class="ls-help-message" v-show="errors.has($t('sellers.trade_name'))">{{ errors.first($t('sellers.trade_name')) }}</small>
                </div>
              </div>

              <!-- Telefone -->
              <div class="input-block" :class="{'ls-error': errors.has($t('sellers.phone')) }">
                <label for="contact[number]" class="col-sm-3 control-label ls-label-text">{{ $t('wizard.step.phone') }}</label>
                <div class="col-sm-12 col-lg-6">
                  <div class="ls-prefix-group">
                    <span class="ls-label-text-prefix"><i class="fa fa-phone" aria-hidden="true"></i></span>
                    <input
                      type="tel"
                      class="form-control"
                      maxlength="16"
                      v-model="full_phone"
                      v-validate="'required|min:14'"
                      :placeholder="$t('wizard.step.ph_phone')"
                      :name="$t('sellers.phone')"
                      @keyup="formatPhone" />
                  </div>
                  <small class="ls-help-message" v-show="errors.has($t('sellers.phone'))">{{ errors.first($t('sellers.phone')) }}</small>
                </div>
              </div>

              <!-- Email -->
              <div class="input-block" :class="[{ 'ls-error': errors.has($t('sellers.email')) }, { 'ls-success':  !errors.has($t('sellers.email')) && emailChanged }]">
                <label for="email" class="col-sm-3 control-label ls-label-text">{{ $t('wizard.step.email') }}</label>
                <div class="col-sm-12 col-lg-6">
                  <div class="ls-prefix-group">
                    <span class="ls-label-text-prefix"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                    <input
                      type="email"
                      class="form-control"
                      v-model="seller.email"
                      v-validate="'required|email'"
                      :value="seller.email"
                      :placeholder="$t('wizard.step.ph_email')"
                      :name="$t('sellers.email')"
                      @keyup="setEmailChanged" />
                  </div>
                  <small class="ls-help-message" v-show="errors.has($t('sellers.email'))">{{ errors.first($t('sellers.email')) }}</small>
                  <small class="ls-help-message" v-show="!errors.has($t('sellers.email')) && emailChanged">{{ $t('settings.label.messages.email_available') }}</small>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="ls-actions-btn">
            <button ref="btnEdit" type="button" class="ls-btn-primary ls-float-right ls-no-margin" @click="nextStep" v-bind:disabled="this.errors.any()">{{ $t('wizard.step.btn_next') }}</button>
          </div>
        </form>
      </div>

      <div class="steps-content" v-if="currentstep == 2">
        <div class="ls-box ls-box-gray ls-md-space">
          <div class="col-md-4">
            <div class="banks">
              <img src="./../../../assets/img/payment.png">
            </div>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-8">
            <h4 class="ls-title-4 ls-md-margin-bottom">{{ $t('wizard.step.configure_payments_title') }}</h4>
             <div v-html="$t('wizard.step.configure_payments_text')"></div>
          </div>
        </div>
        <div class="ls-actions-btn">
          <button type="button" class="ls-btn ls-float-left" @click="goBack">{{ $t('wizard.step.back') }}</button>
          <button type="button" class="ls-btn-primary ls-float-right" @click="goNext">{{ $t('wizard.step.got_it') }}</button>
        </div>
      </div>

      <div class="steps-content" v-if="currentstep == 3">
        <div class="ls-box ls-box-gray ls-txt-center ls-lg-space">
          <h4 class="ls-title-4 ls-md-margin-bottom">{{ $t('wizard.step.endpage_title') }}</h4>
          <p class="ls-md-margin-bottom">{{ $t('wizard.step.endpage_text') }}</p>
          <a @click.prevent="goToPlans" href="javacsript:void(0)" class="ls-btn-primary">{{ $t('wizard.step.btn_create_plan') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as format from 'src/utils/form'

  export default {
    name: 'Steps',
    data () {
      return {
        full_phone: '',
        usernameChanged: false,
        emailChanged: false,
        currentstep: 1,
        steps: [
          { title: this.$t('wizard.step.company_data'), active: true },
          { title: this.$t('wizard.step.payments_methods'), active: false },
          { title: this.$t('wizard.step.conclude'), active: false }
        ]
      }
    },
    computed: {
      ...mapGetters(['user', 'currentUser', 'seller'])
    },
    mounted () {
      this.loadUser(this.currentUser).then(this.afterLoadUser)
    },
    methods: {
      ...mapMutations(['setWizardDone']),
      ...mapActions(['loadUser', 'editSeller']),
      afterLoadUser (response) {
        if (response.status === 200 && this.seller.contact) {
          this.full_phone = format.fullPhone(this.seller.contact.area_code + this.seller.contact.number)
        }
        this.loading = false
      },
      formatPhone () {
        this.full_phone = format.formatPhone(this.full_phone)
      },
      nextStep () {
        this.validateBeforeSubmit()
      },
      setUsernameChanged () {
        this.usernameChanged = true
      },
      setEmailChanged () {
        this.emailChanged = true
      },
      validateBeforeSubmit () {
        this.$refs.btnEdit.disabled = true
        this.$validator.validateAll().then(this.sendForm)
      },
      sendForm (success) {
        if (success) {
          this.submitForm()
        } else {
          this.$refs.btnEdit.disabled = false
        }
      },
      submitForm () {
        this.prepareParameters()
        this.editSeller({ seller: this.seller }).then(this.goToNextStep)
      },
      goToNextStep (response) {
        if (response.status === 200) {
          this.goNext()
        }
        this.$refs.btnEdit.disabled = false
      },
      prepareParameters () {
        var phoneOnlyNumber = this.full_phone.replace(/\D/g, '')
        this.seller.contact_attributes = {
          area_code: phoneOnlyNumber.substr(0, 2),
          number: phoneOnlyNumber.substr(2, 9)
        }
      },
      goNext () {
        this.currentstep += 1
      },
      goBack () {
        this.currentstep -= 1
      },
      goToPlans () {
        this.setWizardDone()
        this.editSeller({ seller: this.seller })
        this.$router.push('/plans')
      }
    }
  }
</script>
<style lang="sass" scoped>
  .step-container
    max-width: 1100px
    margin: 0 auto
    top: 5vh
    position: relative
  .step-indicator
    text-align: center
  .step-indicator li
    display: table-cell
    position: relative
    float: none
    padding: 0
    width: 1%
    .step-number
      border: 1px solid #cacaca
      border-radius: 50%
      color: #cacaca
      font-size: 24px
      padding: 6px
      width: 40px
      height: 40px
      display: inline-block
      vertical-align: middle
      font-weight: lighter
      + button
        color: #cacaca
        border: none
        background: none
        font-size: 18px
        font-weight: lighter
        margin: 10px
        vertical-align: middle
    &.current-step
      .step-number
        background: #1ab551
        border: 1px solid #1ab551
        color: #fff
        + button
          color: #1ab551
  @media screen and (max-width: 1199px)
    .control-label.ls-label-text
      text-align: left
      min-width: 172px
    .check-availability-box
      float: left
      display: inline-block
      padding: 15px
      @media screen and (max-width: 768px)
        width: 100%
        button
          width: 100%
  @media screen and (max-width: 480px)
    .input-block
      &.username
        .ls-prefix-group
          display: initial
        .ls-label-text-prefix
          background: #eaeaea
          height: 33px
        .form-control
          border: 1px solid #dddddd
          border-radius: 0
  .input-block
    margin-bottom: 10px
    display: flex
    @media screen and (max-width: 1199px)
      display: block
    &.ls-error
      label
        color: #d75553!important
      .ls-label-text-prefix
        color: #d75553!important
        border: 1px solid #d75553!important
  .control-label
    text-align: right
    margin-top: 5px
    color: #555555
    font-weight: bold
    line-height: 19.8px
    font-size: 14px
  .form-control
    text-align: left
    width: 100%
  .banks
    margin-bottom: 20px
    img
      margin: 0 auto
      display: block
  @media only screen and (min-width: 768px)
    .custom-steps
      padding: 20px 0
</style>



// WEBPACK FOOTER //
// Steps.vue?7e424e9e